import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import Fetcher from '../../common/util/Fetcher';
import { handleError } from '../../common/api/helpers';
import { addTagAssociation, removePendingAdditionTagAssociation, removePendingDeletionTagAssociation, removeTagAssociation, setTagSuggestions } from '../../common/actions/tagAssociations';
import { GET_TAG_SUGGESTIONS, CREATE_TAG_ASSOCIATION, DELETE_TAG_ASSOCIATION } from '@instructure/quiz-common';
import t from '@instructure/quiz-i18n/format-message';
export var getTagSuggestions = function getTagSuggestions(entryType, entryId, text) {
  return function (dispatch, getState) {
    var url = '/api/tags';
    var urlParams = {
      filter: text
    };
    var fetcher = new Fetcher({
      callType: GET_TAG_SUGGESTIONS,
      onError: handleError(dispatch, t('Failed to search tags.'))
    });
    return fetcher.get(url, urlParams).then(function (tags) {
      return dispatch(setTagSuggestions(entryType, entryId, tags, text));
    });
  };
};
var createTagAssociation = function createTagAssociation(dispatch, bankEntryId, entityType, entityId, tagValue) {
  var url = "/api/bank_entries/".concat(bankEntryId, "/tag_associations");
  var fetcher = new Fetcher({
    callType: CREATE_TAG_ASSOCIATION,
    onError: handleError(dispatch, t('Failed to create tag.'))
  });
  return fetcher.post(url, {
    body: JSON.stringify({
      tag_value: tagValue
    })
  }).then(function (tagAssociation) {
    return dispatch(addTagAssociation(entityType, entityId, tagAssociation));
  });
};
export var createTagAssociations = function createTagAssociations(bankEntryId, entityType, entityId, tagValues) {
  return function (dispatch, getState) {
    return Promise.all(tagValues.map(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(tagValue) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return createTagAssociation(dispatch, bankEntryId, entityType, entityId, tagValue);
            case 2:
              return _context.abrupt("return", dispatch(removePendingAdditionTagAssociation(entityType, entityId, tagValue)));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()));
  };
};
var deleteTagAssociation = function deleteTagAssociation(dispatch, bankEntryId, entityType, entityId, tagAssociationId) {
  var url = "/api/bank_entries/".concat(bankEntryId, "/tag_associations/").concat(tagAssociationId);
  var fetcher = new Fetcher({
    callType: DELETE_TAG_ASSOCIATION,
    onError: handleError(dispatch, t('Failed to delete tag.'))
  });
  return fetcher["delete"](url).then(function (response) {
    return dispatch([removeTagAssociation(entityType, entityId, tagAssociationId)]);
  });
};
export var deleteTagAssociations = function deleteTagAssociations(bankEntryId, entityType, entityId, tagAssociationIds) {
  return function (dispatch, getState) {
    return Promise.all(tagAssociationIds.map(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(tagAssociationId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return deleteTagAssociation(dispatch, bankEntryId, entityType, entityId, tagAssociationId);
            case 2:
              return _context2.abrupt("return", dispatch(removePendingDeletionTagAssociation(entityType, entityId, tagAssociationId)));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()));
  };
};